import { connect } from 'react-redux'

import BannerLayoutOne from 'components/hub-page/views/sections/banner/layouts/one'

const mapStateToProps = (state, ownProps) => ({
  data: state.hubPageRevision.revision.sections[ownProps.sectionId].data[0],
  theme: state.hubPageRevision.revision.sections[ownProps.sectionId].theme,
  meta: state.hubPageRevision.revision.sections[ownProps.sectionId].meta,
  dataTestId: 'participant-hubs-views-banner-section-layout-one',
  brandColor: state.theme.theme.brandColor
})

export default connect(mapStateToProps)(BannerLayoutOne)
